import { ProjectViewModel } from "../../../ViewModel/ProjectViewModel";

export function isFinished(project: ProjectViewModel, spdrOrPdsrId: number | undefined): boolean {
  const ltlPipeline = project?.ltlPipelines?.find(
    (p) => p?.SpdrId === spdrOrPdsrId || p?.PdsrId === spdrOrPdsrId
  );
  if (!ltlPipeline) {
    return false;
  }
  return ltlPipeline.IsFinished || ltlPipeline.JitKanban || false;
}
